<template>
    <div clss="content">
    	<div class="title">数据中心</div>
        <a href="http://datav.aliyuncs.com/share/2d58e737a0f4f283bed8740d32f89862" target="_blank"><div class="banner_count" @click="go_aliyuns"></div></a>
    	<div class="count_total clearfix">
    		<div class="cw_count fl_left">
                <div class="cw_title clearfix">
                    <div class="fl_left title_name">收入统计</div>
                    <div class="fl_right" style="width:245px;margin-right:10px;">
                        <input type="text" style="display:none;">
                        <input type="password" style="display:none;">
                        <el-date-picker class="bordiv" v-model="cw_time" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd" style="width:100%;border:1px solid #e6e6e6;border-radius: 4px;margin-top:9px;" range-separator="~" start-placeholder="开始日期" :clearable = "editabled" :editable = "editabled" @change="cw_count" end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                </div>
                <div class="right_count">
                    <div id="drawcircle" :style="{width: '100%', height: '300px'}"></div>
                </div>
	        	
	        </div>
	        <div class="cw_count fl_right">
                <div class="cw_title">
                    <div class="title_name">承办单位数量统计</div>
                </div>
                <div class="right_count">
                    <div id="myChart" :style="{width: '100%', height: '300px'}"></div>
                </div>
	        </div>
        </div>
        <div class="stu_cw_count">
            <div class="cw_title clearfix">
                <div class="fl_left title_name">考生及财务月统计</div>
                <div class="fl_right" style="margin-right:10px;">
                    <el-radio-group v-model="cw_dance_name" @change="drawLine">
                        <el-radio-button v-for="item in danceName_list" :key="item.id" :label="item.id">{{ item.type == 1 ? item.name+'学生' : item.name+'老师'}}</el-radio-button>
                    </el-radio-group>
                    <input type="text" style="display:none;">
                    <input type="password" style="display:none;">
                    <el-date-picker v-model="year_time" @change="drawLine" type="year" value-format="yyyy" format="yyyy" style="width:100px;margin-top:9px;" :clearable = "editabled" :editable = "editabled" placeholder="选择年"></el-date-picker>
                </div>
            </div>
            <div class="cw_month">
                <div class="clearfix" style="margin: 10px 10px 0 0">
                    <!-- <div class="fl_right">
                        <el-radio-group v-model="cw_or_stu" size="mini">
                            <el-radio-button :label="1">考生</el-radio-button>
                            <el-radio-button :label="2" disabled>财务</el-radio-button>
                        </el-radio-group>
                    </div> -->
                </div>
                <div id="columnar" style="width:100%;height:300px"></div>
            </div>
        </div>
        <div class="stu_cw_count">
            <div class="cw_title clearfix">
                <div class="fl_left title_name">省级分布</div>
                <div class="fl_right" style="margin-right:10px;margin-top:9px;">
                    <el-radio-group v-model="country_dance_name" @change="chianMap">
                        <el-radio-button key="1" label="1">教师</el-radio-button>
                        <el-radio-button key="4" label="4">学生</el-radio-button>
                    </el-radio-group>
                    <input type="text" style="display:none;">
                    <input type="password" style="display:none;">
                </div>
            </div>
            <div class="cw_month clearfix" style="height:auto;">
                <div id="main" style="width:70%;height:450px" class="fl_left"></div>
                <div class="fl_left chinaMap">
                    <!-- <el-table :data="data_province" :summary-method="getSummaries" show-summary v-loading = "loading" height="450px;" style="width: 100%">
                        <el-table-column prop="name" label="地域名"></el-table-column>
                        <el-table-column prop="value" label="考生人数"></el-table-column>
                    </el-table> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    function randomData() {  
         return Math.round(Math.random()*500);  
    }
    // 引入基本模板
    let echarts = require('echarts/lib/echarts')
    // 引入柱状图组件
    require('echarts/lib/chart/bar')
    // 引入提示框和title组件
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')
    //import {mapMutations} from 'vuex'
    export default {
    name: 'login',
        data () {
            return {
                texts:"",
                cw_or_stu:"1",
                loading:true,
                editabled:false,
                cw_dance_name:'754a7162vx84bd6v92c1',
                country_dance_name:'1',
                year_time:new Date().getFullYear() + '',
                cw_time:['2019-08-01','2019-08-31'],
                dataList:['中国舞教师','中国舞学生','芭蕾舞教师','芭蕾舞学生'],
                danceName_list:[],
                data_province: [],
                // student:[1,2,4,5,67,8,9,,1,2,4,5]
            }
        },
        mounted(){
            // this.drawLine();
            // this.com_count();
            // this.chianMap();
            // this.cw_count();
        },
        beforeDestroy() {
            // off(window, "resize", this.resize);
        },
        methods:{
            isRightName: function(name) {
                var reg = /^[a-zA-Z\u4E00-\u9FA5\uF900-\uFA2D\u00B7\u2022\u0095\u0387]+$/;
                var strRe = /[\u4E00-\u9FA5]/g;
                var str = name.match(strRe);
                var strlength;
                if(str == null){
                    strlength = name.length;
                } else {
                    strlength = name.length + str.length * 2; // 汉字按三个字节
                }
                if (strlength <= 3 || strlength > 48) {
                    return false;
                }
                if (!name.match(reg)) {
                    return false;
                }
                else {
                    var headExp = /^[\u00B7\u2022\u0095\u0387]+/;
                    var tailExp = /[\u00B7\u2022\u0095\u0387]+$/;
                    var zhExp = /[\u4E00-\u9FA5\uF900-\uFA2D]+[\s]+/;
                    var zhcharExp = /[\u4E00-\u9FA5\uF900-\uFA2D]+[u00B7\u2022\u0095\u0387]?[a-zA-Z]+/;
                    var charzhExp = /[a-zA-Z]+[u00B7\u2022\u0095\u0387]?[\u4E00-\u9FA5\uF900-\uFA2D]+/;
                    var emptyExp = /\s/g;
                    if (headExp.test(name)) {
                        return false;
                    }
                    if (tailExp.test(name)) {
                        return false;
                    }
                    if (zhExp.test(name)) {
                        return false;
                    }
                    if (zhcharExp.test(name)) {
                        return false;
                    }
                    if (charzhExp.test(name)) {
                        return false;
                    }
                    return true;
                }
            },
            go_aliyuns(){

            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                  if (index === 0) {
                    sums[index] = '总人数';
                    return;
                  }
                  const values = data.map(item => Number(item[column.property]));
                  if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                      const value = Number(curr);
                      if (!isNaN(value)) {
                        return prev + curr;
                      } else {
                        return prev;
                      }
                    }, 0);
                    sums[index] += ' 人';
                  } 
                });

                return sums;
            },
            //收入统计环形图
            cw_count(){
                let _this = this;
                //console.log(_dataList)
                // 基于准备好的dom，初始化echarts实例
                const myChart = this.$echarts.init(document.getElementById('drawcircle'));
                myChart.showLoading();
                
               // _this.dataList = []
                _this.$axios.post('statistics/income',{start_date:_this.cw_time[0], end_date:_this.cw_time[1]}).then( res =>{
                    if(res.data.code == 200){
                        //option.series[0].data = res.data.data
                        myChart.setOption({
                            aria: {
                                show: true
                            },
                            color:['#36cbcb','#4ecb73','#3aa1ff','#f2637b'],
                            tooltip: {
                                trigger: 'item',
                                formatter: "{a} <br/>{b}: {c} ({d}%)",
                            },
                            
                            series: [
                                {
                                    name:'收入统计',
                                    type:'pie',
                                    radius: ['50%', '70%'],
                                    center:[200,'50%'],
                                    avoidLabelOverlap: false,
                                    stillShowZeroSum: false,
                                    zlevel: 1,
                                    label: {
                                        normal: {
                                            show: false,
                                            formatter:'{b}\n{c}',
                                            position: 'center'
                                        },
                                        emphasis: {
                                            show: true,
                                            textStyle: {
                                                fontSize: '22',
                                                fontWeight: 'bold'
                                            }
                                        }
                                    },
                                    labelLine: {
                                        normal: {
                                            show: false
                                        }
                                    },
                                    data:res.data.data
                                }
                            ],
                            legend: {
                                orient: 'vertical',
                                y: 'center',
                                x: 'right',
                                data:res.data.data,
                                itemGap: 30,
                                top: 'middle',
                                align: 'left',
                                icon: 'circle',
                                formatter:  function(name){
                                    var total = 0;
                                    var target;
                                    for (var i = 0, l = res.data.data.length; i < l; i++) {
                                        if (res.data.data[i].name == name) {
                                            target = res.data.data[i].value;
                                        }
                                    }
                                    var arr = [name +  '  ' +target + '元']
                                    return arr
                                },
                            },
                        });
                        myChart.hideLoading();
                    }
                    else{
                        _this.$Message.error(res.data.message)
                    }
                }).catch( error =>{
                    console.log(error)
                })
            },
            
            //省市分布中国地图
            chianMap(){ 
                let _this = this ;
                //初始化echarts实例
                var myChart = echarts.init(document.getElementById('main'));
                myChart.showLoading();
                _this.loading = true
                echarts.registerMap('china', chinaJson);
                //var optionMap = ;  
                //_this.dataList = [] 
                _this.$axios.post('statistics/province',{dance_id:_this.country_dance_name}).then( res =>{
                    // console.log(res.data)
                    if(res.data.code == 200){
                        _this.data_province = res.data.data
                        //optionMap.series[0].data = res.data.data
                        //_this.dataList = 
                        _this.loading = false
                        //使用制定的配置项和数据显示图表
                        myChart.setOption({  
                        backgroundColor: '#FFFFFF',  
                        tooltip : {  
                            trigger: 'item' ,
                            //formatter:function(params,ticket, callback){
                             //   return params.seriesName+'<br />'+params.name+'：'+params.value
                            //}//数据格式化
                        },  
                        
                        //左侧小导航图标
                        visualMap: {  
                            show :true, 
                            // min: 0,
                            // max: 30000, 
                            x: 'left',  
                            y: 'center',  
                            // splitList: [   
                            //     {start: 200, end:5000000},{start: 150, end: 200},  
                            //     {start: 100, end: 150},{start: 50, end: 100},  
                            //     {start: 10, end: 50},{start: 0, end: 10},  
                            // ],  
                           color: ['rgba(88,175,255,1)','rgba(88,175,255,.8)', 'rgba(88,175,255,.6)', 'rgba(88,175,255,.4)','rgba(88,175,255,.2)']  
                        }, 

                        geo: {
                            map: 'china',
                            roam: false,
                            zoom: 1.2,
                            label: {
                                normal: {
                                    show: true,
                                    textStyle: {
                                        color: '#3ebee6'                        //省份字体颜色
                                    }
                                },
                                emphasis: {  
                                    show: true  
                                }
                            },
                            // itemStyle: {
                            //     normal: {
                            //         borderColor: 'rgba(0, 0, 0, 0.2)'
                            //     },
                            //     emphasis: {
                            //         areaColor: null,
                            //         shadowOffsetX: 0,
                            //         shadowOffsetY: 0,
                            //         shadowBlur: 20,
                            //         borderWidth: 0,
                            //         shadowColor: 'rgba(0, 0, 0, 0.5)'
                            //     }
                            // }
                        }, 
                        
                        //配置属性
                        series: [{  
                            name: '考生人数',  
                            type: 'map',  
                            zoom: 1.2,
                            //type: 'scatter',
                            coordinateSystem: 'geo',
                            mapType: 'china',   
                            roam: false,  
                            label: {  
                                normal: {  
                                    show: true,  //省份名称  
                                },  
                                emphasis: {  
                                    show: true  
                                }  
                            },  

                            data:res.data.data  //数据
                        }]  
                    });
                        myChart.hideLoading();
                    }
                    else{
                        _this.$Message.error(res.data.message)
                    }
                }).catch( error =>{
                    console.log( error)
                })
            },

            //承办单位数量统计环形图
            com_count(){
                let _this = this;
                //console.log(_dataList)
                // 基于准备好的dom，初始化echarts实例
                const myChart = this.$echarts.init(document.getElementById('myChart'));
                myChart.showLoading();

                _this.$axios.post('statistics/company',{}).then( res =>{
                    if(res.data.code == 200){
                        //option.series[0].data = res.data.data
                        myChart.setOption({
                            color:['#36cbcb','#4ecb73','#3aa1ff','#f2637b'],
                            tooltip: {
                                trigger: 'item',
                                // formatter: "{b}: {c} ({d}%)"
                                formatter: "{a} <br/>{b}: {c} ({d}%)",
                            },
                            legend: {
                                orient: 'vertical',
                                y: 'center',
                                x: 'right',
                                data:res.data.data,
                                itemGap: 30,
                                top: 'middle',
                                align: 'left',
                                icon: 'circle',
                                formatter:  function(name){
                                    var total = 0;
                                    var target;
                                    for (var i = 0, l = res.data.data.length; i < l; i++) {
                                        if (res.data.data[i].name == name) {
                                            target = res.data.data[i].value;
                                        }
                                    }
                                    var arr = [name +  '  ' +target + '家']
                                    return arr
                                },
                            },
                            series: [
                                {
                                    name:'承办单位数量',
                                    type:'pie',
                                    radius: ['50%', '70%'],
                                    center:[200,'50%'],
                                    avoidLabelOverlap: false,
                                    label: {
                                        normal: {
                                            show: false,
                                            formatter:'{b}\n{c}',
                                            position: 'center'
                                        },
                                        emphasis: {
                                            show: true,
                                            textStyle: {
                                                fontSize: '22',
                                                fontWeight: 'bold'
                                            }
                                        }
                                    },
                                    labelLine: {
                                        normal: {
                                            show: false
                                        }
                                    },
                                    data: res.data.data,
                                }
                            ]
                        });
                        myChart.hideLoading();
                    }
                    else{
                        _this.$Message.error(res.data.message)
                    }
                }).catch( error =>{
                    console.log( error)
                })
            },

            //柱状图
            drawLine(){
                let _this = this;
                // 基于准备好的dom，初始化echarts实例
                let myChart = this.$echarts.init(document.getElementById('columnar'))
                myChart.showLoading();
                // 绘制图表
                const option = {
                    color:'#58afff',
                    tooltip: {},
                    xAxis: {
                        data: ["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"]
                    },
                    yAxis: [
                        {
                            alignWithLabel:true,
                            name : '考生人数',
                        }
                    ],
                    series: [{
                        name: '考生人数',
                        type: 'bar',
                        label: {
                              normal: {
                                  show: true,
                                  position: 'top',
                                  textStyle: {
                                    color: '#333'
                                  }
                              }
                        },
                        data: [],
                    }]
                }
                _this.$axios.post('statistics/student',{dance_id:_this.cw_dance_name,year:_this.year_time}).then( res =>{
                    if(res.data.code == 200){
                        // _this.student = res.data.data
                        option.series[0].data = res.data.data
                        myChart.setOption(option);
                        myChart.hideLoading();
                    }
                    else{
                        _this.$Message.error(res.data.message)
                    }
                }).catch( error =>{
                    console.log(error)
                })
                
            },
            dance_name(){
                let _this = this;
                _this.$axios.post('dancelist',{}).then( res =>{
                    if(res.data.code == 200){
                        _this.danceName_list = res.data.data
                    }
                    else{
                        _this.$Message.error(res.data.message)
                    }
                }).catch( error =>{
                    console.log(error)
                })
            },
        },
        created(){
            // let _this = this ;
            // _this.dance_name()
            // var date = new Date();
            // var year = date.getFullYear()
            // var month = date.getMonth() + 1;
            // var day ;
            // if(month == 1|3|5|7|8|10|12){
            //     day = 31;
            // }
            // else if(  month == 2){
            //     if( year % 4 == 0 &&  (year % 100 != 0 || year % 400 == 0) ){
            //         day = 29;
            //     }
            //     else{
            //         day = 28;
            //     }
            // }
            // else{
            //     day = 30 ;
            // }
            // this.cw_time = [ year + '-' + (month = month > 9 ? month : '0' + month) + '-01' , year + '-' + month +'-'+ day]
        }
    };
</script>

<style scoped>
.title{
    line-height: 58px;
    color: #303030;
    font-size: 18px;
}
.banner_count{background: url(../../../static/imgs/banner_logo.png) center center no-repeat;height: 108px; background-size: 100%;}
.cw_count{width: 49%;border: 1px solid #e6e6e6;background: #fff;box-sizing: border-box;}
.cw_title{padding-left: 30px;height: 50px;border-bottom: 1px solid #e6e6e6;}
.title_name{font-size: 15px;color: #333;line-height: 50px;}
.right_count{padding-right: 30px;}
.stu_cw_count{background: #fff;border: 1px solid #e6e6e6;margin-top: 20px;margin-bottom: 20px;}
.cw_month{width: 100%;height: 300px;}
.chinaMap{box-sizing: border-box;margin-top: 30px;border-left: 1px solid #e6e6e6;padding-left: 30px;width: 29%;}
</style>


// WEBPACK FOOTER //
// src/components/data/dataCount.vue